// Font Awesome Pro icons - tree-shaken
// To add a new icon:
//   1. Find it at https://fontawesome.com/icons
//   2. Note its style (solid, light, brands, etc.)
//   3. Import it below from the matching @fortawesome/* package
//   4. Add it to the library.add(...) call at the bottom
//   5. Use it in templates as <font-awesome-icon :icon="['fal', 'name']" />

import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faArchive,
    faArrowsRotate,
    faArrowUpRightFromSquare,
    faBan,
    faBold,
    faBox,
    faBoxArchive,
    faBuildingColumns,
    faCalendar,
    faCalendarAlt,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircleCheck,
    faCircleInfo,
    faCircleNotch,
    faCircleSmall,
    faCircleX,
    faCircleXmark,
    faClockRotateLeft,
    faCloudArrowDown,
    faCloudArrowUp,
    faCode,
    faCreditCard,
    faDollar,
    faDollarSign,
    faDownload,
    faEdit,
    faEnvelope,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkAlt,
    faEye,
    faEyes,
    faEyeSlash,
    faFiles,
    faGift,
    faHand,
    faHome,
    faHouse,
    faInboxOut,
    faInfoCircle,
    faItalic,
    faLink,
    faListOl,
    faListUl,
    faMapMarkerAlt,
    faMapPin,
    faMinus,
    faMoneyCheck,
    faMoneyCheckDollar,
    faOctagonExclamation,
    faPaperPlane,
    faPause,
    faPencil,
    faPenToSquare,
    faPeopleRoof,
    faPhone,
    faPlay,
    faPlus,
    faPrint,
    faQuestionCircle,
    faQuoteRight,
    faRefresh,
    faRotateLeft,
    faRotateRight,
    faShareFromSquare,
    faShield,
    faShieldAlt,
    faShieldCheck,
    faSort,
    faSortDown,
    faSortUp,
    faSquareChevronLeft,
    faStar,
    faStars,
    faSync,
    faTable,
    faTimes,
    faTools,
    faTrash,
    faUnderline,
    faUnlink,
    faUser,
    faUserCheck,
    faWrench,
    faXmark,
} from '@fortawesome/pro-solid-svg-icons'

import {
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowsRotate as faArrowsRotateLight,
    faArrowUp,
    faBars,
    faBell,
    faBlog,
    faBoxArchive as faBoxArchiveLight,
    faBuilding,
    faBullhorn,
    faCalendarAlt as faCalendarAltLight,
    faCalendar as faCalendarLight,
    faChartPie,
    faCheckCircle as faCheckCircleLight,
    faCheck as faCheckLight,
    faChevronDown as faChevronDownLight,
    faChevronLeft as faChevronLeftLight,
    faChevronRight as faChevronRightLight,
    faCircleExclamation,
    faClipboardListCheck,
    faClose,
    faComments,
    faCommentsDollar,
    faCopy,
    faCreditCard as faCreditCardLight,
    faDollar as faDollarLight,
    faDollarSign as faDollarSignLight,
    faDroplet,
    faExclamation as faExclamationLight,
    faExclamationTriangle as faExclamationTriangleLight,
    faFaceMonocle,
    faFileContract,
    faFileMagnifyingGlass,
    faFiles as faFilesLight,
    faFlag,
    faGraduationCap,
    faHandshake,
    faHome as faHomeLight,
    faHouseBuilding,
    faHouseLock,
    faHouseUser,
    faHouseWater,
    faIdCard,
    faInfoCircle as faInfoCircleLight,
    faLandmark,
    faLock,
    faLockOpen,
    faMagnifyingGlass,
    faMapMarkerAlt as faMapMarkerAltLight,
    faMapPin as faMapPinLight,
    faPartyHorn,
    faPersonChalkboard,
    faPhone as faPhoneLight,
    faQuestion,
    faQuestionCircle as faQuestionCircleLight,
    faRightFromBracket,
    faRightToBracket,
    faRuler,
    faScreenUsers,
    faScrewdriverWrench,
    faShareFromSquare as faShareFromSquareLight,
    faShieldCheck as faShieldCheckLight,
    faShieldExclamation,
    faSignOut,
    faSquareDollar,
    faStar as faStarLight,
    faTimesCircle,
    faTimes as faTimesLight,
    faTriangleExclamation,
    faUserAlt,
    faUser as faUserLight,
    faWrench as faWrenchLight,
    faXmark as faXmarkLight,
} from '@fortawesome/pro-light-svg-icons'

import {
    faFacebook,
    faInstagram,
    faLinkedin,
    faLinkedinIn,
    faSquareFacebook,
    faSquareWhatsapp,
    faXTwitter,
} from '@fortawesome/free-brands-svg-icons'

library.add(
    faArchive,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowUpRightFromSquare,
    faArrowsRotate,
    faArrowsRotateLight,
    faBan,
    faBars,
    faBell,
    faBlog,
    faBold,
    faBox,
    faBoxArchive,
    faBoxArchiveLight,
    faBuilding,
    faBuildingColumns,
    faBullhorn,
    faCalendar,
    faCalendarAlt,
    faCalendarAltLight,
    faCalendarLight,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckCircleLight,
    faCheckLight,
    faChevronDown,
    faChevronDownLight,
    faChevronLeft,
    faChevronLeftLight,
    faChevronRight,
    faChevronRightLight,
    faChevronUp,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faCircleNotch,
    faCircleSmall,
    faCircleX,
    faCircleXmark,
    faClipboardListCheck,
    faClockRotateLeft,
    faClose,
    faCloudArrowDown,
    faCloudArrowUp,
    faCode,
    faComments,
    faCommentsDollar,
    faCopy,
    faCreditCard,
    faCreditCardLight,
    faDollar,
    faDollarLight,
    faDollarSign,
    faDollarSignLight,
    faDownload,
    faDroplet,
    faEdit,
    faEnvelope,
    faExclamation,
    faExclamationCircle,
    faExclamationLight,
    faExclamationTriangle,
    faExclamationTriangleLight,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faEyes,
    faFaceMonocle,
    faFacebook,
    faFileContract,
    faFileMagnifyingGlass,
    faFiles,
    faFilesLight,
    faFlag,
    faGift,
    faGraduationCap,
    faHand,
    faHandshake,
    faHome,
    faHomeLight,
    faHouse,
    faHouseBuilding,
    faHouseLock,
    faHouseUser,
    faHouseWater,
    faIdCard,
    faInboxOut,
    faInfoCircle,
    faInfoCircleLight,
    faInstagram,
    faItalic,
    faLandmark,
    faLink,
    faLinkedin,
    faLinkedinIn,
    faListOl,
    faListUl,
    faLock,
    faLockOpen,
    faMagnifyingGlass,
    faMapMarkerAlt,
    faMapMarkerAltLight,
    faMapPin,
    faMapPinLight,
    faMinus,
    faMoneyCheck,
    faMoneyCheckDollar,
    faOctagonExclamation,
    faPaperPlane,
    faPartyHorn,
    faPause,
    faPenToSquare,
    faPencil,
    faPeopleRoof,
    faPersonChalkboard,
    faPhone,
    faPhoneLight,
    faPlay,
    faPlus,
    faPrint,
    faQuestion,
    faQuestionCircle,
    faQuestionCircleLight,
    faQuoteRight,
    faRefresh,
    faRightFromBracket,
    faRightToBracket,
    faRotateLeft,
    faRotateRight,
    faRuler,
    faScreenUsers,
    faScrewdriverWrench,
    faShareFromSquare,
    faShareFromSquareLight,
    faShield,
    faShieldAlt,
    faShieldCheck,
    faShieldCheckLight,
    faShieldExclamation,
    faSignOut,
    faSort,
    faSortDown,
    faSortUp,
    faSquareChevronLeft,
    faSquareDollar,
    faSquareFacebook,
    faSquareWhatsapp,
    faStar,
    faStarLight,
    faStars,
    faSync,
    faTable,
    faTimes,
    faTimesCircle,
    faTimesLight,
    faTools,
    faTrash,
    faTriangleExclamation,
    faUnderline,
    faUnlink,
    faUser,
    faUserAlt,
    faUserCheck,
    faUserLight,
    faWrench,
    faWrenchLight,
    faXTwitter,
    faXmark,
    faXmarkLight,
)
